import { SALEHOO_TOOL_MAX_EMBED_HEIGHT } from './embedConfig';

export function getUrlOrigin(url, base) {
    if (!url) {
        return '';
    }

    try {
        return new URL(url, base).origin;
    } catch (error) {
        return '';
    }
}

export function getValidatedEmbedHeight(value) {
    const height = Math.ceil(Number(value));

    if (!Number.isFinite(height) || height <= 0 || height > SALEHOO_TOOL_MAX_EMBED_HEIGHT) {
        return 0;
    }

    return height;
}
